<template>
  <section class="grid detail">
    <div
      class="detail__inner container--small"
      data-anim="text"
      v-html="data.text"
    />
  </section>
</template>

<script>
export default {
  name: 'Detail',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  padding: 0 0 rem(60px) 0;

  @include mq(ipadP) {
    padding: 0 0 rem(200px) 0;
  }
}
</style>
